<template>
  <section class="scrollable padder">
    <div v-if="loading" class="loading">Loading&#8230;</div>
    
    <section class="panel panel-default">
     
      <div class="modal-body">
        <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addEdit)" method="post">
          <div class="row">  
          <div class="col-md-12">
             <ValidationProvider
               name="Project Name"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="customer-name">
                Project Name <span class="required-color">*</span></label
              >
              <input
                class="form-control"
                type="text"
                id="project-name"
                v-model="projectName"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid name"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Project Name"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div>
              <div class="col-md-6">
                <ValidationProvider name="Customer" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Customer</label>
                  <select
                    class="form-control"
                    v-model="customerId"
                    name="customer"
                    style="width: 100%;"
                  >
                    <option id="term" selected value=""
                      >Choose Customer</option
                    >
                    <option
                      v-for="customer in customerList"
                      :key="customer.customer_id"
                      v-bind:value="customer.customer_id"
                      >{{ customer.customer_name }}</option
                    >
                  </select>
                   <span style="color:red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              </div>
              <div class="col-md-6">
                <ValidationProvider name="contact person" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Contact Person</label>
                 <input
                type="text"
                class="form-control"
                id="contact-person"
                v-model="contactPerson"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid name"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Contact Person"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
          <div class="col-sm-12">
             <ValidationProvider
               name="Site Address"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="address">
                Address <span class="required-color">*</span></label
              >
              <input
                class="form-control"
                type="text"
                id="address"
                v-model="siteAddress"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid address"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Customer Address"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div>
          <!--
              <div class="col-md-4">
                <ValidationProvider name="city" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> City</label>
                 <input
                type="text"
                class="form-control"
                id="city"
                v-model="siteCity"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid city anme"
                data-parsley-trigger="keyup"
                value=""
                placeholder="City"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-4">
                <ValidationProvider name="PO Box" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> P.O Box</label>
                 <input
                type="text"
                class="form-control"
                id="poBox"
                v-model="sitePO"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid P.O Box number"
                data-parsley-trigger="keyup"
                value=""
                placeholder="P.O Box"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-4">
                <ValidationProvider name="payment-term" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Country</label>
                  <select
                    class="form-control"
                    v-model="siteCountry"
                    name="payment_term"
                    style="width: 100%;"
                  >
                    <option id="term" selected value=""
                      >Choose Country</option
                    >
                    <option
                      v-for="country in countryList"
                      :key="country"
                      v-bind:value="country"
                      >{{ country }}</option
                    >
                  </select>
                   <span style="color:red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              </div>
              -->
              <div class="col-md-6">
                <ValidationProvider name="phone" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Phone</label>
                 <input
                type="text"
                id="phone"
                class="form-control"
                v-model="sitePhone"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid phone number"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Phone"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-6">
                <ValidationProvider name="mobile" rules="" v-slot="{ errors }">
                <div class="form-group">
                  <label> Mobile</label>
                 <input
                type="text"
                class="form-control"
                id="mobile"
                v-model="siteMobile"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid mobile number"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Mobile"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
          </div>
          <div class="modal-footer" style="text-align: right">
           
            <button
              :disabled="saveCat"
              id="btn_save"
              type="submit"
              class="btn btn-success  text-center  "
            >
              Save
            </button>
             <a
              v-on:click="$emit('hide-form')"
              class="btn btn-danger  text-center  "
            >
              Close
            </a>
          </div>
        </form>
        </ValidationObserver>
      </div>
      
    </section>
  </section>
</template>

<script>
import api from "../api";
import config from '../config'

export default {
  props: ["projectId"],
  name: "AddProject",
  data() {
    return {
      saveCat: false,
      itemId: '',
      customerId: '',
      projectName: '',
      contactPerson: '',
      siteAddress: '',
      countryList: config.countryList,
      siteCity: '',
      sitePO: '',
      siteCountry: '',
      sitePhone: '',
      siteMobile: '',
      errors : [],
      customerList: [],
      loading: false,
    };
  },
  methods: {
    getCustomer: function() {
      const list = {filter: {}};
      api
        .request("post", "GeneralApis/get_customers", list)
        .then((response) => {
          var data = response.data;
          if (data.errorcode) {
            this.customerList = response.data.values;
          } else {
            this.customerList = data.customerList;
          }
        });
    },
    addEdit() {
       this.loading = false
      this.saveCat = true;
      this.itemId = this.$props.projectId;
      this.errors = []
      if (!this.projectName) {
        this.errors.push("Project Name is required.");
      }
      if(!this.errors.length){
      const addItem = {
        "project-form": {
          project_id: this.itemId,
          customer_id: this.customerId,
          project_name: this.projectName,
          contact_person: this.contactPerson,
          site_city: this.siteCity,
          site_po: this.sitePO,
          site_country: this.siteCountry,
          site_phone: this.sitePhone,
          site_mobile: this.siteMobile,
          site_address: this.siteAddress
        },
      };
      if (this.itemId > 0) {
        api
          .request("post", "GeneralApis/edit_project", addItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Updated");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      } else {
        api
          .request("post", "GeneralApis/add_project", addItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Added");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      }
      }
    },
    getProject: function() {
      var project_id = this.$props.projectId;
        (this.projectName = ""),
        (this.contactPerson = ""),
        (this.siteCity = ""),
        (this.sitePO = ""),
        (this.siteCountry = ""),
        (this.siteMobile = ""),
        (this.siteAddress = ""),
        (this.sitePhone = ""),
        (this.itemId = 0);
      if (project_id > 0) {
        this.itemId = project_id;

        const getItem = {
          filter: {
            project_id: this.itemId,
          },
        };
        api
          .request("post", "GeneralApis/get_projects", getItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              const projectList = data.projectList[0];
              this.projectName = projectList.project_name;
              this.siteAddress = projectList.project_address;
              this.sitePhone = projectList.project_phone;
              this.contactPerson = projectList.contact_person;
              this.siteCity = projectList.project_city;
              this.sitePO = projectList.project_po;
              this.siteCountry = projectList.project_country;
              this.sitePhone = projectList.project_phone;
              this.siteMobile = projectList.project_mobile;
              this.customerId = projectList.customer_id;
            }
          });
      }
    },
  },
  mounted() {
    this.getProject();
    this.getCustomer();
  },
};
</script>
